<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="480px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <div
        class="flex"
        style="
          padding: 27px 20px;
          background: linear-gradient(180deg, #dcf0ff 0%, rgba(255, 255, 255, 0) 100%);
          border-radius: 4px 4px 0px 0px;
        "
      >
        <div style="margin-left: 20px">
          <div
            style="
              font-family: MiSans, MiSans;
              font-weight: 500;
              font-size: 18px;
              color: #494c4f;
              line-height: 26px;
            "
          >
            更换部门
          </div>
        </div>
      </div>
      <el-form :model="formInline" ref="form" style="padding: 0 24px">
        <el-form-item label="部门" prop="backReason">
          <el-select
            filterable
            placeholder="请选择社区"
            clearable
            v-model="formInline.deptId"
          >
            <el-option
              v-for="item in deptList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="addOrUpdateFun">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { changeR4Dept } from "@/api/task.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    },
    deptList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      formInline: {
        deptId: ""
      },
      rules: {
        typeName: [
          { required: true, message: "请输入点位类型", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async addOrUpdateFun() {
      let params = {
        deptId: this.formInline.deptId,
        handleId: this.curItem.taskHandleId
      };
      let res = await changeR4Dept(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 0px 0px;
}

/deep/ .el-dialog__header {
  display: none;
}

/deep/.el-input {
  width: auto !important;
}

.flex {
  display: flex;
  align-items: center;
}
/deep/.el-dialog {
  margin-top: 16vh !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/reportproblemAnalysis/components/changeWg.vue